import './CollapsibleCardList.scoped.scss'

export default function CollapsibleCardList({ children, initialLimit = 8, singleRow = false }) {
  const [expanded, setExpanded] = useState(false)
  const [rowLimit, setRowLimit] = useState(initialLimit)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!singleRow) return

    function measure() {
      const container = containerRef.current
      if (!container) return

      const firstChild = container.querySelector(':scope > *')
      if (!firstChild) return

      const containerWidth = container.offsetWidth
      const containerStyle = window.getComputedStyle(container)
      const childStyle = window.getComputedStyle(firstChild)
      const gap = parseFloat(containerStyle.gap) || 0
      const marginLeft = parseFloat(childStyle.marginLeft) || 0
      const marginRight = parseFloat(childStyle.marginRight) || 0
      const childWidth = firstChild.offsetWidth + marginLeft + marginRight + gap

      setRowLimit(Math.max(1, Math.floor((containerWidth + gap) / childWidth)))
    }

    measure()
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [singleRow])

  const childArray = React.Children.toArray(children)
  const limit = singleRow ? rowLimit : initialLimit
  const hasMore = childArray.length > limit
  const displayChildren = expanded ? childArray : childArray.slice(0, limit)

  return (
    <div className="collapsible-card-list">
      <div ref={containerRef} className="collapsible-card-list-items">
        {displayChildren}
      </div>
      {hasMore && (
        <button
          className="collapsible-card-list-toggle"
          onClick={() => setExpanded(!expanded)}
          type="button"
        >
          {expanded ? 'See less' : `See more (${childArray.length - limit})`}
        </button>
      )}
    </div>
  )
}
